import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
const objections = [{
  question: 'No tengo tiempo para entrenar',
  answer: 'El sistema está diseñado para adaptarse a tu agenda. Cada sesión dura entre 30-45 minutos y podés entrenar 3-4 veces por semana. Los ejercicios son específicos y eficientes, sin relleno.'
}, {
  question: '¿Sirve si soy principiante?',
  answer: 'Absolutamente. El Manual del Enganche empieza desde fundamentos básicos y progresa gradualmente. Cada tomo está estructurado para que puedas avanzar a tu ritmo, sin importar tu nivel actual.'
}, {
  question: '¿Es solo teoría o tiene ejercicios prácticos?',
  answer: 'El 70% del contenido son ejercicios prácticos con instrucciones paso a paso, videos explicativos y rutinas completas. La teoría está presente solo para que entiendas el "por qué" detrás de cada ejercicio.'
}, {
  question: '¿Cómo lo recibo?',
  answer: 'Inmediatamente después de la compra recibirás un email con acceso al contenido completo en formato digital. Podés descargarlo en tu celular, tablet o computadora y acceder cuando quieras.'
}, {
  question: '¿Y si no me sirve?',
  answer: 'Tenés 30 días de garantía total. Si sentís que el sistema no cumplió tus expectativas, te devolvemos el 100% de tu dinero sin preguntas. Nuestro objetivo es que mejores tu juego, no solo vender.'
}];
export function Objections() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white py-16 md:py-24" data-id="element-90">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-91">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-92">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-3" data-id="element-93">
          {objections.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-94">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors" data-id="element-95">
                <div className="flex items-center gap-4" data-id="element-96">
                  <HelpCircle className="w-6 h-6 text-emerald-600 flex-shrink-0" data-id="element-97" />
                  <span className="text-left font-semibold text-gray-900" data-id="element-98">
                    {item.question}
                  </span>
                </div>
                <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-99" />
              </button>

              <AnimatePresence data-id="element-100">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-101">
                    <div className="px-6 py-4 bg-gray-50 border-t border-gray-200" data-id="element-102">
                      <p className="text-gray-700" data-id="element-103">{item.answer}</p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}